import { Store } from '@ngrx/store';

import { SidebarCommandProps, SidebarCustomCommandProps, SidebarView } from '../../domain/models/sidebar.models';
import { SidebarCommandsInterface } from '../public/public.port';
import { CloseSidebarCustom } from '../state/sidebar.actions';

import { SidebarCommand, SidebarCommands, SidebarCustomCommand } from './sidebar.command';

import { Command } from '@core/domain/ports/primary/cqrs/command.interface';

export class SidebarCommandsFacade implements SidebarCommandsInterface {
    private readonly store: Store;

    constructor(store: Store) {
        this.store = store;
    }

    public openSidebar(view: SidebarView): void {
        const sidebarCommand: Command<SidebarCommandProps> = {
            module: 'SidebarCoreModule',
            path: () => import('@features/sidebar/sidebar.module').then((m) => m.SidebarCoreModule),
            key: SidebarCommands.OPEN_SIDEBAR,
            props: { view },
        };

        const sidebarCommandHandler = new SidebarCommand(this.store);
        sidebarCommandHandler.handle(sidebarCommand);
    }

    public closeSidebar(isNavigation?: boolean) {
        this.store.dispatch(CloseSidebarCustom({ isNavigation }));
    }

    public openSidebarCustom(props: SidebarCustomCommandProps): void {
        const sidebarCommand: Command<SidebarCustomCommandProps> = {
            module: 'SidebarCoreModule',
            path: () => import('@features/sidebar/sidebar.module').then((m) => m.SidebarCoreModule),
            key: SidebarCommands.OPEN_SIDEBAR_CUSTOM,
            props,
        };

        const sidebarCommandHandler = new SidebarCustomCommand(this.store);
        sidebarCommandHandler.handle(sidebarCommand);
    }
}
